import { apiClient, handleApiRequest } from './client'

export interface TokenShopEntry {
  field: string
  confirmed: boolean
  confirmed_at?: string | null
}

export async function listTokenShop(field?: string): Promise<Record<string, TokenShopEntry>> {
  const data = await handleApiRequest<{ tokens: Record<string, TokenShopEntry> }>(
    apiClient.get('/api/v1/token-shop/', { params: field ? { field } : undefined }),
  )
  return data.tokens || {}
}

export async function deleteTokenShop(tokenName: string): Promise<void> {
  await apiClient.delete(`/api/v1/token-shop/${encodeURIComponent(tokenName)}`)
}
